import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Delete Course lecture resources
 * @param course_id
 * @param version
 * @param resourceId
 */
const deleteCourseLectureResource = (
  course_id: string,
  version: number,
  resourceId: string
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE + course_id + '/' + version + '/resources/' + resourceId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.delete(URL, config)
      .then(() => {
        resolve()
      })
      .catch((err) => {
        reject('Error occured while deleting Lecture content: ' + err)
      })
  })
}
export default deleteCourseLectureResource
